import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MemberInformationService } from '../member-information.service';
import { DumbAccountInfo } from '../DTOs/dumb-account-info';

@Component({
  selector: 'app-member-account',
  templateUrl: './member-account.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MemberAccountComponent {

    constructor(private blockUI: UIBlockingService
        , private router: Router
        , private route: ActivatedRoute
        , private notificationService: ToastNotificationService
        , private fb: FormBuilder
        , private memberInformationService: MemberInformationService
    ) { }

    myUser: DumbAccountInfo = new DumbAccountInfo();

    firstNameCtrl = new FormControl("firstName", [Validators.required]);
    lastNameCtrl = new FormControl("lastName", [Validators.required]);
    emailAddressCtrl = new FormControl("emailAddress", [Validators.required, Validators.email]);

    accountInfoForm: FormGroup = new FormGroup({
        firstName: this.firstNameCtrl,
        lastName: this.lastNameCtrl,
        emailAddress: this.emailAddressCtrl,
    });

    firstName() { return this.accountInfoForm.get('firstName').value }
    lastName() { return this.accountInfoForm.get('lastName').value }
    emailAddress() { return this.accountInfoForm.get('emailAddress').value }

    ngOnInit() {
        this.resetStepOneForm();
    }

    private resetStepOneForm(): void {
        this.accountInfoForm.reset();
        this.myUser.firstName = localStorage.getItem('userFirstName');
        this.myUser.lastName = localStorage.getItem('userLastName');
        this.myUser.emailAddress = localStorage.getItem('userEmailAddress');
        this.accountInfoForm.patchValue({
            firstName: this.myUser.firstName,
            lastName: this.myUser.lastName,
            emailAddress: this.myUser.emailAddress,
        });
    }

    saveAccountInfo() {
        this.myUser.firstName = this.firstName();
        this.myUser.lastName = this.lastName();
        this.myUser.emailAddress = this.emailAddress();

        this.blockUI.start()
        this.memberInformationService.updateAccountInfo(this.myUser).subscribe({
            next: (data) => {
                this.updateLocalStorage(data);
                window.location.reload();
                this.blockUI.stop();
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
            },
        })
        
    }

    updateLocalStorage(user) {
        localStorage.setItem('userFirstName', user.firstName);
        localStorage.setItem('userLastName', user.lastName);
        localStorage.setItem('userEmailAddress', user.emailAddress);
    }
}
